export function routeGuard(to, from, next) {
  if (from.query.feature && !to.fullPath.includes('feature')) {
    to.query.feature = from.query.feature
    if (!to.fullPath.includes('feature') && !to.fullPath.includes('?')) {
      next({path: `${to.fullPath}?feature=${from.query.feature}`})
    } else {
      next({path: `${to.fullPath}&feature=${from.query.feature}`})
    }
  }
  next()
}
